export type UpdateHistoryItem = {
  date: string;
  title: string;
};

export const UPDATE_HISTORY_ITEMS: UpdateHistoryItem[] = [
  {
    date: "2026.08.13",
    title: "デザイン「ボード」追加／「ウェーブホール」のテキストサイズ微調整",
  },
  {
    date: "2026.06.27",
    title: "「使い方」を実装／スマホレイアウト整形",
  },
  {
    date: "2026.06.23",
    title: "デザイン「ウェーブホール」追加／配信おやすみの文言を可変に",
  },
  {
    date: "2026.06.10",
    title: "「このツールについて」「不具合・要望報告」を追加",
  },
  {
    date: "2026.06.04",
    title: "配信スケジュール画像生成ツール「はいすけ」公開",
  },
];
